import { render, staticRenderFns } from "./InternalReviewSection.vue?vue&type=template&id=5601e2e4"
import script from "./InternalReviewSection.vue?vue&type=script&lang=ts"
export * from "./InternalReviewSection.vue?vue&type=script&lang=ts"
import style0 from "./InternalReviewSection.vue?vue&type=style&index=0&id=5601e2e4&prod&lang=css&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InternalReviewCarousel: require('/app/components/generic/InternalReviewCarousel.vue').default})
